import React, { useEffect } from 'react';
import { Route } from 'react-router';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Path from 'routes/Path';
import HeaderCompany from 'components/HeaderCompany/HeaderCompany';
import { Spinner } from 'components/Spinner/spinner';
import { manageZendeskButton } from 'functions/zendesk';

export default function CompanyRoute({ component: Component, authMode, zendesk = 'show', ...rest }) {
  const history = useHistory();
  const { isInitialized, userId } = useSelector((state) => state.auth);

  useEffect(() => manageZendeskButton(zendesk), [zendesk]);

  useEffect(() => {
    if (!authMode || !isInitialized) return;
    if (!userId && authMode === 'private') history.push(Path.loginPage);
    if (userId && authMode === 'unauthed') history.push(Path.landingPage);
  }, [authMode, isInitialized, userId, history]);

  const renderPage = (props) => (
    <>
      <HeaderCompany />
      {!authMode || isInitialized ? <Component {...props} _id={userId} /> : <Spinner />}
    </>
  );

  return <Route {...rest} render={(props) => renderPage(props)} />;
}
